import DataQueries from '../graphql/Queries';
import PagingModel from './PagingModel';
import { getPermittedSorts } from './MasterDataSettingsModel';
import PrioritySortMenuModel from '../ui/PrioritySortMenuModel';
import locationDialogModel from '../schedule/LocationDialogModel';
import mainPageModel from '../main-navigation/MainPageModel';
import SettingsModel, { DefaultSchema } from './SettingsModel';
import { LocationSort } from '../DataTypes';

export default class LocationsSettingsModel extends SettingsModel {
  constructor() {
    super('Location', 'locations', locationDialogModel);

    function load(this: LocationsSettingsModel, filter?: { search?: string }): Promise<{ cursor?: string; totalCount: number }> {
      if (!this.sortModel || !this._documentType || !filter) return Promise.resolve({ cursor: undefined, totalCount: 0 });
      const permittedKeys = this.sortModel.getSortMenuItems().map((i: { name: string }) => i.name);
      const sorts = getPermittedSorts(this.sortModel.sorts, this._documentType, permittedKeys);
      return this._load(filter, sorts);
    }

    this.paging = new PagingModel(load.bind(this));
    this.sortModel = new PrioritySortMenuModel(
      () => this.paging.load(true),
      () => this.getSortMenuItems(),
    );
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddLocations;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditLocations;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteLocations;
  }

  getSortMenuItems(): { name: string; title: string; isCustom?: boolean }[] {
    return [
      { name: 'name', title: 'Name' },
      { name: 'code', title: 'Code' },
      // ...udfsSubscriptionService.subscriptionModel.getUdfsByDocumentType(this._documentType).map((udf: IUdf) => (
      //   {name: udf.name, title: udf.displayName, isCustom: true}
      // ))
    ];
  }

  protected async _load(filter: { search?: string }, sort?: LocationSort) {
    const results = await DataQueries.getLocations(DefaultSchema, filter, sort, this.paging.itemsPerPage, this.paging.currentPage);
    this.setItems(results.data);
    return results;
  }
}
